import PropTypes from 'prop-types'
import React from 'react'
import { withOrientationChange } from 'react-device-detect'

import errorConfig from 'components/PreClass/Checklist/components/Troubleshoot/config'
import { checklistErrorTypes } from 'constants/checklist'
import { userTypes } from 'helpers/user'

import { Container } from './styles'

import Heading from '../common/Heading'

const {
    AUDIO_VIDEO,
    USER_NOT_ALLOWED,
    TEACHER_ALREADY_PRESENT,
    ROOM_FULL,
    AUDIO_404,
    VIDEO_404,
} = checklistErrorTypes

const Troubleshoot = ({ error, userType, ...props }) => {
    const { ErrorComponent, ...rest } = errorConfig(userType)[error]

    const hideHeading = [
        AUDIO_VIDEO,
        ROOM_FULL,
        USER_NOT_ALLOWED,
        TEACHER_ALREADY_PRESENT,
    ].includes(error?.toUpperCase())

    const justifyContent = [AUDIO_404, VIDEO_404].includes(error) && 'center'

    return (
        <Container justifyContent={justifyContent}>
            <Heading {...rest} hide={hideHeading} />
            <ErrorComponent {...rest} {...props} />
        </Container>
    )
}

Troubleshoot.propTypes = {
    error: PropTypes.oneOf(Object.values(checklistErrorTypes)).isRequired,
    userType: PropTypes.oneOf(Object.values(userTypes)).isRequired,
}

export default withOrientationChange(Troubleshoot)
